export default __webpack_public_path__ + "static/media/SportELS_Posterior.b1880b62.webp";